import React from "react";

import Image from "components/Image";
import BlogPostMetadata from "components/BlogPostMetadata";
import getIcon from "components/Icons";
import { LinkButton } from "components/Buttons/Buttons";

import * as styles from "./BlogFeatuerdPost.module.less";

/**
 * @typedef {object} Props
 * @prop {string} title
 * @prop {string} date
 * @prop {readonly string[]} [tags]
 * @prop {GatsbyTypes.BlogPostThumbnailImageFragment} thumbnail
 * @prop {string} excerpt
 * @prop {string} path
 * @prop {string} linkButtonIcon
 * @prop {string} linkButtonText
 *
 *
 * @param {Props} props
 */
export default function BlogFeaturedPost({
  title,
  date,
  tags,
  thumbnail,
  excerpt,
  path,
  linkButtonText,
  linkButtonIcon,
}) {
  const image = thumbnail.image ? (
    <Image
      src={thumbnail.image.thumbnailImage}
      title={thumbnail.caption || title}
      alt={thumbnail.alt || title}
      publicURL={thumbnail.image.publicURL}
      className={styles.image}
    />
  ) : null;

  return (
    <section>
      <article className={styles.container}>
        <div className={styles.description}>
          <h2>{title}</h2>
          <BlogPostMetadata
            className={styles.metadata}
            date={date}
            tags={tags}
          />
          <p className={styles.excerpt}>{excerpt}</p>
          <LinkButton
            to={path}
            isContent
            title={linkButtonText}
            // @ts-expect-error
            icon={getIcon(linkButtonIcon, { width: 30 })}
          />
        </div>
        {image}
      </article>
    </section>
  );
}
